import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap} from "gsap";
import {BigWinLevel, TrueGritWinConfigs} from "../../configs/TrueGritWinConfigs";
import {TrueGritSound} from "../../sound/TrueGritSound";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";


/**
 * Created by Jerker Nord on 2021-09-14.
 */

export class TrueGritTotalBigWinRunner implements SimplePresentation {
    private _totalBetWays:number = 0;

    constructor() {
    }

    shouldRun():boolean {
        for(let i:number = 0; i < TrueGrit.model.gameData.betWayWins.length; i++) {
            this._totalBetWays += TrueGrit.model.gameData.betWayWins[i].numberOfCombinations;
        }

        if((TrueGritGameMode.isEndOfAvalanche(TrueGrit.model.gameData.mode, TrueGrit.model.gameData.nextMode) && TrueGrit.model.winRatio >= 15 && !TrueGrit.model.data.brokeBank)) {
            return true;
        }
        if(TrueGritGameMode.isEndOfAvalanche(TrueGrit.model.gameData.mode, TrueGrit.model.gameData.nextMode)) {
            //Set to 0 if it's a non Big Win
            this._totalBetWays = 0;
            return false;
        } else {
            // not any kind of avalanche, and mode is same as nextMode means that it is 0 win round at all, handling it from here else need to add a Presentation for this.
            if ((TrueGrit.model.gameData.mode.indexOf("AVALANCHE") === -1) && (TrueGrit.model.gameData.mode === TrueGrit.model.gameData.nextMode)) {
                TrueGrit.trueGritGritGirlSymbols.goBackAllToOffState();
            }
            return false;
        }
    }

    private getLevelSound(level:number){
       return TrueGritSound.BIG_WIN_LEVEL_PREFIX  + level;

    }

    start(controller:SimplePresentationRunnerController):void {
        const levels:BigWinLevel[] = TrueGritWinConfigs.getBigWinLevels(TrueGrit.model.winRatio);

        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});
        TrueGrit.totalBigWinView.precalculateScale(TrueGrit.model.winRatio * TrueGrit.model.gameData.playedBetValue);

        tl.add(() => TrueGrit.trueGritGritGirlSymbols.goBackAllToOffState());

        tl.add(() => TrueGrit.soundPlayer.fadeMusic(1,0,2000));

        let introDuration = 1.425;
        let levelAborted = false;
        for(let level of levels) {
            const levelSound = this.getLevelSound(level.id);
            tl.add(()=>{levelAborted = false;});
            tl.add(()=> {TrueGrit.soundPlayer.playSound(levelSound)});
            if (level.id == 1){
                tl.add(this.getBigWinIntro(introDuration));
            }
            tl.add(() => controller.setSkipCallback(() => {
                levelAborted = true;
                tl.seek(level.name + "_end", false);
            }));

            tl.add(TrueGrit.totalBigWinView.getLevelAnimation(level.from * TrueGrit.model.gameData.playedBetValue, level.to * TrueGrit.model.gameData.playedBetValue, level.duration, level.id));
            tl.addLabel(level.name + "_end");
            tl.add(() => controller.setSkipCallback());
            tl.add(()=>{
                if(levelAborted){
                    TrueGrit.soundPlayer.stopSound(levelSound);
                }
            });
        }
        tl.add(() => {
            TrueGrit.soundPlayer.playSound(TrueGritSound.BIG_WIN_ENDS);

            // #511
            TrueGrit.totalBigWinView.stopBigWinCountUpAt(TrueGrit.model.gameData.totalAvalancheRoundWinnings);
        });
        tl.add(() => TrueGrit.soundPlayer.fadeMusic(0,1,1000));

        tl.add(TrueGrit.totalBigWinView.show(introDuration*0.7), introDuration - introDuration*0.7);
        tl.add(TrueGrit.totalBigWinView.getImageScalingAnimation(tl.duration()), introDuration);
        tl.add(TrueGrit.totalBigWinView.showNumberOfWays(this._totalBetWays, 0.2));
        tl.add(() => TrueGrit.keypadPlugin.setWin(TrueGrit.model.data.accumulatedRoundWin, true, TrueGrit.isWinBelowStake()));
        tl.add(TrueGrit.totalBigWinView.hide(0.5), ">1.5");
        tl.add(() => {this._totalBetWays = 0});
    }

    set totalBetWays(value:number) {
        this._totalBetWays = value;
    }

    private getBigWinIntro(duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        const symbols = TrueGrit.allReelsView.getAllVisibleSymbols();

        for (let symbol of symbols){
            tl.add((<TrueGritSymbol>symbol).getShakeAnimation(duration),0);
        }

        return tl;
    }
}